import React, { Component } from 'react';
import ReportPage from './ReportPage';
import Questions from '../../entities/questions.json';
import DOL from '../../img/img-dol.png';
import GlidePathsPage from './GlidePathsPage';
import GrowthPathsPage from './GrowthPathsPage';

export default class SummaryPage extends Component {
    getAnswer(qid, normalizeText){
        if (!this.props.responses)return null;
        let response = this.props.responses[qid];
        if (response){
            let text = response.selected ? (response.selected.outputText || response.selected.text) : null;
            if (!text)text = response.altSelected ? (response.altSelected.outputText || response.altSelected.text) : null;
            if (!text)return;
            text = text.replace('<br/>', ' ');
            if (normalizeText){
                let firsChar = text[0];
                text = firsChar.toLowerCase() + text.slice(1);
            }
            return <span className="emphasis">{text}</span>
        }else{
            return null;
        }        
    }

    getValue(qid){
        if (!this.props.responses)return null;
        return this.props.responses[qid];
    }

    getAltAnswer(qid, normalizeText){
        if (!this.props.responses)return null;
        let response = this.props.responses[qid];
        if (!response)return null;
        if (response.selected.text === 'No')return null;
        let altSelected = response.altSelected;
        if (response && altSelected){
            let text = altSelected.outputText || altSelected.text;
            if (text === "Other"){
                text = response.altOther || text;
            }
            text = text.replace('<br/>', ' ');
            if (normalizeText){
                let firsChar = text[0];
                text = firsChar.toLowerCase() + text.slice(1);
            }
            return <span className="emphasis">{text}</span>
        }else{
            return null;
        }
        
    }  
    
    getTip(qid){
        let data = Questions[qid];
        return data.tip || '';
    }

    getAnswerAddendum(qid){
        let response = this.props.responses[qid];
        if (!response)return null;
        let resp = <span className="highlight space-before">It may be necessary to consider replacing the fund.</span>;
        let respEm = <span className="emphasis">{resp}</span>;
        if (response.selected) {
            switch(qid){
                case 2: 
                    return response.selected.text === 'Yes' ? resp : null;
                case 3: 
                    return response.selected.text === 'Yes' ? resp: null;
                case 4: 
                    return response.selected.id === '2' ? resp: null;
                case 5: 
                    return response.selected.text === 'Yes' ? resp: null;                
                case 6: 
                    return response.selected.text === 'Yes' ? respEm: null;
                case 7: 
                    return response.selected.id !== '3' ? respEm: null;                
                default:
                    return '';
            }
        } else {
            return '';
        }
    }

    render() {
        let pageIncByGlide = 1;
        if(this.props.glidePath && this.props.glideOptimized){
            pageIncByGlide = 1;
        }else if(this.props.glidePath || this.props.glideOptimized){
            pageIncByGlide = 0;
        }else{
            pageIncByGlide = -1;
        }
        let isReview = false; 
        
        var resourcesToShow = "Target-Date Blueprint"
					if (this.getValue('resources')) resourcesToShow = this.getValue('resources')

        if (this.props.responses){
            if (this.props.responses['1']){
                isReview = this.props.responses['1'].selected.id === '1';
            }            
        }
        let subtitle = "Below includes information inputted for " + this.props.preparedFor + " and aligns the information to the corresponding U.S. Department of Labor <em>Target Date Retirement Funds -Tips for ERISA Plan Fiduciaries</em>, February 2013.";
        let contentList =  [
            <ReportPage key={'qr1'} title={this.props.preparedFor + ' Information'} {...this.props} subtitle={subtitle} longSubtitle={true} addBreak={true} className="questionnaire-results" pageNumber={this.props.pageNumber}>
                <p>
                    <b className="text-blue">Establish a process for the periodic review of selected TDFs.</b> 
                </p>    
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>Plan fiduciaries are required to periodically review the plan's investment options to ensure that they should continue to be offered. At a minimum, the review process should include examining whether there have been any significant changes in the information fiduciaries considered when the option was selected or last reviewed. For instance, if a TDF's investment strategy or management team changes significantly, or if the fund's manager is not effectively carrying out the fund's stated investment strategy, then <span className="highlight">it may be necessary to consider replacing the fund</span>. Similarly, if your plan's objectives in offering a TDF change, you should consider replacing the fund.</p>
                </div>                
                {isReview ? 
                    <div>
                        <h6 className="text-underline">Periodic Review Information for {this.props.preparedFor}:</h6>
                        <p>The following is a result of the latest periodic review:</p>
                        <ul>
                            <li>
                                The TDF investment strategy {this.getAnswer('2')} changed significantly. {this.getAnswerAddendum(2)}<br/>
                                {this.getAltAnswer('2')} 
                            </li>
                            <li className="mt-2">
                                The TDF management team {this.getAnswer('3')} changed significantly. {this.getAnswerAddendum(3)}<br/>
                                {this.getAltAnswer('3')} 
                            </li>
                            <li className="mt-2">
                                The fund's manager {this.getAnswer('4')} effectively carried out the fund's stated investment strategy. {this.getAnswerAddendum(4)}<br/>                            
                            </li>
                            <li className="mt-2">
                                The plan's objective in offering the TDF {this.getAnswer('5')} changed. {this.getAnswerAddendum(5)}<br/>
                                {this.getAnswer('5') === 'has' ? 'The ' + this.getAltAnswer('5') : ''} 
                            </li>
                            <li className="mt-2">
                                {this.getAnswer('6')} {this.getAnswerAddendum(6)}
                            </li>                            
                            <li className="mt-2">
                                {this.getAnswer('7')} {this.getAnswerAddendum(7)}
                            </li>                                                
                        </ul>    
                    </div>   
                : 
                    null                     
                }   
                { false? 
                    <div>
                        <p>The plan's objective in offering a TDF is: </p>
                        <p>{this.getAnswer('16')}</p>
                    </div>  
                : null }  
            </ReportPage>,
            <ReportPage key={'qr2'} title={this.props.preparedFor + ' Information'} {...this.props} addBreak={true} className="questionnaire-results" pageNumber={this.props.pageNumber + 1}>
                <p>
                    <b className="text-blue">Establish a process for comparing and selecting TDFs.</b> 
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>In general, plan fiduciaries should engage in an objective process to obtain information that will enable them to evaluate the prudence of any investment option made available under the plan. For example, in selecting a TDF you should consider prospectus information, such as information about performance (investment returns) and investment fees and expenses. You should consider how well the TDF's characteristics align with eligible employees' ages and likely retirement dates. It also may be helpful for plan fiduciaries to discuss with their prospective TDF providers the possible significance of other characteristics of the participant population, such as participation in a traditional defined benefit pension plan offered by the employer, salary levels, turnover rates, contribution rates and withdrawal patterns.</p>
                </div>
                <h6 className="text-underline">Eligible Employee Characteristics for {this.props.preparedFor}:</h6>
                <p>
                    A majority of employees for the reviewed plan {this.props.preparedFor} were {this.getAnswer('8', true)} with the highest concentration in assets belonging to those {this.getAnswer('9', true)}.
                </p>
                <p>
                    Most employees plan to retire at age {this.getAnswer('10')}.
                </p>
                <p>
                    {this.getAnswer('11')}.
                </p>                
                <p>
                    The average salary level of the participant who invests in TDFs in this plan is {this.getAnswer('12', true)}.
                </p>
                <p>
                    The turnover rate is {this.getAnswer('13', true)} and the average contribution rate for employees in this industry is {this.getAnswer('14', true)}.
                </p>
                <p>
                    The average contribution rate for the plan is {this.getAnswer('14', true)}.
                </p>                
                <p>
                    Following retirement, a majority of employees choose to {this.getAnswer('15', true)}.
                </p>              
            </ReportPage>,
            <ReportPage key={'qr3'} title={this.props.preparedFor + ' Information'} {...this.props} addBreak={true} className="questionnaire-results" pageNumber={this.props.pageNumber + 2}>        
                <p>
                    <b className="text-blue">Understand the fund's investments – the allocations to different asset classes (stocks, bonds, cash), individual investments, and how they will change over time.</b> 
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>Have you looked at the fund's prospectus or offering materials? Do you understand the principal strategies and risks of the fund, or of any underlying asset classes or investments that may be held by the TDF? Make sure you understand the fund's glide path, including when the fund will reach its most conservative asset allocation and whether that will occur at or after the target date. Some funds keep a sizeable investment in more volatile assets, like stocks, even as they pass their “target” retirement dates. Since these funds continue to invest in stock, your employees' retirement savings may continue to have some investment risk after they retire. These funds are generally for employees who don't expect to withdraw all of their 401(k) account savings immediately upon retirement, but would rather make periodic withdrawals over the span of their retirement years. Other TDFs are concentrated in more conservative and less volatile investments at the target date, assuming that employees will want to cash out of the plan on the day they retire. If the employees don't understand the fund's glide path assumptions when they invest, they may be surprised later if it turns out not to be a good fit for them.</p>
                </div>
                <h6 className="text-underline">TDF Characteristics of {this.props.preparedFor}:</h6>
                <p>
                    The plan objective {this.getAnswer('16', true)}.
                </p>  
                <p>
                    {this.getAnswer('17')}
                </p>
                <p>
                    The average plan participant’s level of total savings suggests {this.getAnswer('18', true)} for their target date strategy.
                </p>
                <p>
                    The likely behavior for an employee nearing retirement following a stock market decline of 20% is {this.getAnswer('19', true)}.
                </p>
            </ReportPage>,
            <GlidePathsPage {...this.props} key="glide" addBreak={true} className="questionnaire-results" optimalPage={false} pageNumber={this.props.pageNumber + 3} />,
            <GlidePathsPage {...this.props} key="glideOptimized" addBreak={true} className="questionnaire-results" optimalPage={true} pageNumber={this.props.pageNumber + 3 + pageIncByGlide} />,
            <GrowthPathsPage {...this.props} key="growthOptimized" addBreak={true} className="questionnaire-results" optimalPage={true} pageNumber={this.props.pageNumber + 4 + pageIncByGlide} />,
            <ReportPage key={'qr4'} title={this.props.preparedFor + ' Information'} {...this.props} addBreak={true} className="questionnaire-results" pageNumber={this.props.pageNumber + 5 + pageIncByGlide}>
                <p className="">
                    <b className="text-blue">Review the fund's fees and investment expenses.</b> 
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>TDF costs can vary significantly, both in the amount and types of fees. Small differences in investment fees and costs can have a serious impact on reducing long term retirement savings. Do you understand the fees and expenses, including any sales loads, for the TDF? If the TDF invests in other funds, did you consider the fees and expenses for both the TDF and the underlying funds? If the expense ratios of the individual component funds are substantially less than the overall TDF, you should ask what services and expenses make up the difference. Added expenses may be for asset allocation, rebalancing and access to special investments that can smooth returns in uncertain markets, and may be worth it, but it is important to ask.</p>
                </div>
                <h6 className="text-underline">Fees and Expense Information:</h6>
                <p>
                    Fees and investment expenses and risk and performance <span className="emphasis">have been or will be evaluated prior to final selection</span>.
                </p>    
                <p className="footnote">
                    *Please find basic fee and performance information in the appendix
                </p>            
                <p className="mt-5">
                    <b className="text-blue">Inquire about whether a custom or non-proprietary target date fund would be a better fit for your plan.</b> 
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>Some TDF vendors may offer a pre-packaged product which uses only the vendor's proprietary funds as the TDF component investments. Alternatively, a “custom” TDF may offer advantages to your plan participants by giving you the ability to incorporate the plan's existing core funds in the TDF. Non- proprietary TDFs could also offer advantages by including component funds that are managed by fund managers other than the TDF provider itself, thus diversifying participants' exposure to one investment provider. There are some costs and administrative tasks involved in creating a custom or non- proprietary TDF, and they may not be right for every plan, but you should ask your investment provider whether it offers them.</p>
                </div>
                <h6 className="text-underline">Target Date Vendor Information:</h6>
                <p>
                    Pre-packaged products from the vendor, as well as, custom and/or non-proprietary TDFs have been considered.
                </p>
            </ReportPage>,
            <ReportPage key={'qr5'} title={this.props.preparedFor + ' Information'} {...this.props} addBreak={true} className="questionnaire-results" pageNumber={this.props.pageNumber + 6 + pageIncByGlide}>
                <p className="">
                    <b className="text-blue">Develop effective employee communications.</b>
                </p>                               
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>
                        Have you planned for the employees to receive appropriate information about TDFs in general, as a retirement investment option, 
                        and about individual TDFs available in the plan? Just as it is important for the plan fiduciary to understand TDF basics when 
                        choosing a TDF investment option for the plan, employees who are responsible for investing their individual accounts need information too. 
                        Disclosures required by law also must be considered. The Department published a final rule that, starting for most plans in August 2012, 
                        requires that participants in 401(k)-type individual account retirement plans receive greater information about the fees and expenses 
                        associated with their plans, including specific fee and expense information about TDFs and other investment options available under their plans. 
                        The Department of Labor is also working on regulations to improve
                        the disclosures that must be made to participants specifically about TDFs. For example, in addition to general information about TDFs, the proposed 
                        regulations call for disclosures to include an explanation that an investment in a TDF is not guaranteed and that participants can lose money in the fund, 
                        including at and after the target date. Check EBSA's website for updates on regulatory disclosure requirements.</p>
                </div>
                <h6 className="text-underline">Employee Communication Information:</h6>
                <p>
                    General and specific TDF information will be shared with appropriate employees. When applicable, the advisor will work with the recordkeeper to provide this information.
                </p>
                <p>
                    EBSA's website will be reviewed for updates on regulatory disclosure requirements.
                </p>
            </ReportPage>,
            <ReportPage key={'qr6'} title={this.props.preparedFor + ' Documentation'} {...this.props} addBreak={this.props.addBreak} className="questionnaire-results" pageNumber={this.props.pageNumber + 7 + pageIncByGlide}>
                <p className="mt-5">
                    <b className="text-blue">Take advantage of available sources of information to evaluate the TDF and recommendations you received regarding the TDF selection.</b> 
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>While TDFs are relatively new investment options, there are an increasing number of commercially available sources for information and services to assist plan fiduciaries in their decision-making and review process.</p>
                </div>
                <h6 className="text-underline">Sources of Information:</h6>
                <p>
                    During this process the following sources for information and services were used:<br/>
                
                    
                    {resourcesToShow}
                    
                </p>
            </ReportPage>,
            <ReportPage key={'qr7'} title={this.props.preparedFor + ' Documentation'} {...this.props} addBreak={this.props.addBreak} className="questionnaire-results" pageNumber={this.props.pageNumber + 8 + pageIncByGlide}>
                {this.props.comments?
                    <div style={{ maxHeight: '440px', overflow: 'hidden' }}>
                        <p className="">
                            <b className="text-blue">Additional Comments</b>
                        </p>
                        {this.props.comments.split('\n').map((p, pi) => <p key={'com' + pi}>{p}</p>)}
                    </div>
                : null }
                <p className={this.props.comments ? 'mt-4' : ''}>
                    <b className="text-blue">Document the process.</b>
                </p>
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>Plan fiduciaries should document the selection and review process, including how they reached decisions about individual investment options.</p>
                </div>
                <div className="signature-line">
                    <div>Advisor</div>
                    <span>Signature</span>
                    <span>Date</span>
                </div>
                <div className="signature-line">
                    <div>Plan Sponsor</div>
                    <span>Signature</span>
                    <span>Date</span>
                </div>
                <div className="signature-line mt-5">
                    <div>Plan Administrator and/or Plan Fiduciary</div>
                    <span>Signature</span>
                    <span>Date</span>
                </div>
            </ReportPage>
        ];

        if(this.props.glidePath && !this.props.glideOptimized){
            contentList.splice(4,1)
        }else if(!this.props.glidePath && this.props.glideOptimized){
            contentList.splice(3,1)
        }else if(!this.props.glidePath && !this.props.glideOptimized){
            contentList.splice(3,2)
        }

        return contentList;
    }
}
